var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray");

// Copyright 2019-2020 @polkadot/wasm-crypto authors & contributors
// SPDX-License-Identifier: Apache-2.0
var asmFallback = require('./wasm/asm-empty');

var wasmBytes = require('./wasm/bytes');

var _require = require('./bridge'),
    allocString = _require.allocString,
    allocU8a = _require.allocU8a,
    getWasm = _require.getWasm,
    initWasm = _require.initWasm,
    resultString = _require.resultString,
    resultU8a = _require.resultU8a,
    withWasm = _require.withWasm;

var imports = require('./imports');

var wasmPromise = initWasm(wasmBytes, asmFallback, imports).catch(function () {
  return null;
});
module.exports.bip39Generate = withWasm(function (wasm, words) {
  wasm.ext_bip39_generate(8, words);
  return resultString();
});
module.exports.bip39ToEntropy = withWasm(function (wasm, phrase) {
  var _allocString = allocString(phrase),
      _allocString2 = _slicedToArray(_allocString, 2),
      ptr0 = _allocString2[0],
      len0 = _allocString2[1];

  wasm.ext_bip39_to_entropy(8, ptr0, len0);
  return resultU8a();
});
module.exports.bip39ToMiniSecret = withWasm(function (wasm, phrase, password) {
  var _allocString3 = allocString(phrase),
      _allocString4 = _slicedToArray(_allocString3, 2),
      ptr0 = _allocString4[0],
      len0 = _allocString4[1];

  var _allocString5 = allocString(password),
      _allocString6 = _slicedToArray(_allocString5, 2),
      ptr1 = _allocString6[0],
      len1 = _allocString6[1];

  wasm.ext_bip39_to_mini_secret(8, ptr0, len0, ptr1, len1);
  return resultU8a();
});
module.exports.bip39ToSeed = withWasm(function (wasm, phrase, password) {
  var _allocString7 = allocString(phrase),
      _allocString8 = _slicedToArray(_allocString7, 2),
      ptr0 = _allocString8[0],
      len0 = _allocString8[1];

  var _allocString9 = allocString(password),
      _allocString10 = _slicedToArray(_allocString9, 2),
      ptr1 = _allocString10[0],
      len1 = _allocString10[1];

  wasm.ext_bip39_to_seed(8, ptr0, len0, ptr1, len1);
  return resultU8a();
});
module.exports.bip39Validate = withWasm(function (wasm, phrase) {
  var _allocString11 = allocString(phrase),
      _allocString12 = _slicedToArray(_allocString11, 2),
      ptr0 = _allocString12[0],
      len0 = _allocString12[1];

  var ret = wasm.ext_bip39_validate(ptr0, len0);
  return ret !== 0;
});
module.exports.ed25519KeypairFromSeed = withWasm(function (wasm, seed) {
  var _allocU8a = allocU8a(seed),
      _allocU8a2 = _slicedToArray(_allocU8a, 2),
      ptr0 = _allocU8a2[0],
      len0 = _allocU8a2[1];

  wasm.ext_ed_from_seed(8, ptr0, len0);
  return resultU8a();
});
module.exports.ed25519Sign = withWasm(function (wasm, pubkey, seckey, message) {
  var _allocU8a3 = allocU8a(pubkey),
      _allocU8a4 = _slicedToArray(_allocU8a3, 2),
      ptr0 = _allocU8a4[0],
      len0 = _allocU8a4[1];

  var _allocU8a5 = allocU8a(seckey),
      _allocU8a6 = _slicedToArray(_allocU8a5, 2),
      ptr1 = _allocU8a6[0],
      len1 = _allocU8a6[1];

  var _allocU8a7 = allocU8a(message),
      _allocU8a8 = _slicedToArray(_allocU8a7, 2),
      ptr2 = _allocU8a8[0],
      len2 = _allocU8a8[1];

  wasm.ext_ed_sign(8, ptr0, len0, ptr1, len1, ptr2, len2);
  return resultU8a();
});
module.exports.ed25519Verify = withWasm(function (wasm, signature, message, pubkey) {
  var _allocU8a9 = allocU8a(signature),
      _allocU8a10 = _slicedToArray(_allocU8a9, 2),
      ptr0 = _allocU8a10[0],
      len0 = _allocU8a10[1];

  var _allocU8a11 = allocU8a(message),
      _allocU8a12 = _slicedToArray(_allocU8a11, 2),
      ptr1 = _allocU8a12[0],
      len1 = _allocU8a12[1];

  var _allocU8a13 = allocU8a(pubkey),
      _allocU8a14 = _slicedToArray(_allocU8a13, 2),
      ptr2 = _allocU8a14[0],
      len2 = _allocU8a14[1];

  var ret = wasm.ext_ed_verify(ptr0, len0, ptr1, len1, ptr2, len2);
  return ret !== 0;
});
module.exports.blake2b = withWasm(function (wasm, data, key, size) {
  var _allocU8a15 = allocU8a(data),
      _allocU8a16 = _slicedToArray(_allocU8a15, 2),
      ptr0 = _allocU8a16[0],
      len0 = _allocU8a16[1];

  var _allocU8a17 = allocU8a(key),
      _allocU8a18 = _slicedToArray(_allocU8a17, 2),
      ptr1 = _allocU8a18[0],
      len1 = _allocU8a18[1];

  wasm.ext_blake2b(8, ptr0, len0, ptr1, len1, size);
  return resultU8a();
});
module.exports.keccak256 = withWasm(function (wasm, data) {
  var _allocU8a19 = allocU8a(data),
      _allocU8a20 = _slicedToArray(_allocU8a19, 2),
      ptr0 = _allocU8a20[0],
      len0 = _allocU8a20[1];

  wasm.ext_keccak256(8, ptr0, len0);
  return resultU8a();
});
module.exports.pbkdf2 = withWasm(function (wasm, data, salt, rounds) {
  var _allocU8a21 = allocU8a(data),
      _allocU8a22 = _slicedToArray(_allocU8a21, 2),
      ptr0 = _allocU8a22[0],
      len0 = _allocU8a22[1];

  var _allocU8a23 = allocU8a(salt),
      _allocU8a24 = _slicedToArray(_allocU8a23, 2),
      ptr1 = _allocU8a24[0],
      len1 = _allocU8a24[1];

  wasm.ext_pbkdf2(8, ptr0, len0, ptr1, len1, rounds);
  return resultU8a();
});
module.exports.scrypt = withWasm(function (wasm, password, salt, log2n, r, p) {
  var _allocU8a25 = allocU8a(password),
      _allocU8a26 = _slicedToArray(_allocU8a25, 2),
      ptr0 = _allocU8a26[0],
      len0 = _allocU8a26[1];

  var _allocU8a27 = allocU8a(salt),
      _allocU8a28 = _slicedToArray(_allocU8a27, 2),
      ptr1 = _allocU8a28[0],
      len1 = _allocU8a28[1];

  wasm.ext_scrypt(8, ptr0, len0, ptr1, len1, log2n, r, p);
  return resultU8a();
});
module.exports.sha512 = withWasm(function (wasm, data) {
  var _allocU8a29 = allocU8a(data),
      _allocU8a30 = _slicedToArray(_allocU8a29, 2),
      ptr0 = _allocU8a30[0],
      len0 = _allocU8a30[1];

  wasm.ext_sha512(8, ptr0, len0);
  return resultU8a();
});
module.exports.twox = withWasm(function (wasm, data, rounds) {
  var _allocU8a31 = allocU8a(data),
      _allocU8a32 = _slicedToArray(_allocU8a31, 2),
      ptr0 = _allocU8a32[0],
      len0 = _allocU8a32[1];

  wasm.ext_twox(8, ptr0, len0, rounds);
  return resultU8a();
});
module.exports.sr25519DeriveKeypairHard = withWasm(function (wasm, pair, cc) {
  var _allocU8a33 = allocU8a(pair),
      _allocU8a34 = _slicedToArray(_allocU8a33, 2),
      ptr0 = _allocU8a34[0],
      len0 = _allocU8a34[1];

  var _allocU8a35 = allocU8a(cc),
      _allocU8a36 = _slicedToArray(_allocU8a35, 2),
      ptr1 = _allocU8a36[0],
      len1 = _allocU8a36[1];

  wasm.ext_sr_derive_keypair_hard(8, ptr0, len0, ptr1, len1);
  return resultU8a();
});
module.exports.sr25519DeriveKeypairSoft = withWasm(function (wasm, pair, cc) {
  var _allocU8a37 = allocU8a(pair),
      _allocU8a38 = _slicedToArray(_allocU8a37, 2),
      ptr0 = _allocU8a38[0],
      len0 = _allocU8a38[1];

  var _allocU8a39 = allocU8a(cc),
      _allocU8a40 = _slicedToArray(_allocU8a39, 2),
      ptr1 = _allocU8a40[0],
      len1 = _allocU8a40[1];

  wasm.ext_sr_derive_keypair_soft(8, ptr0, len0, ptr1, len1);
  return resultU8a();
});
module.exports.sr25519DerivePublicSoft = withWasm(function (wasm, pubkey, cc) {
  var _allocU8a41 = allocU8a(pubkey),
      _allocU8a42 = _slicedToArray(_allocU8a41, 2),
      ptr0 = _allocU8a42[0],
      len0 = _allocU8a42[1];

  var _allocU8a43 = allocU8a(cc),
      _allocU8a44 = _slicedToArray(_allocU8a43, 2),
      ptr1 = _allocU8a44[0],
      len1 = _allocU8a44[1];

  wasm.ext_sr_derive_public_soft(8, ptr0, len0, ptr1, len1);
  return resultU8a();
});
module.exports.sr25519KeypairFromSeed = withWasm(function (wasm, seed) {
  var _allocU8a45 = allocU8a(seed),
      _allocU8a46 = _slicedToArray(_allocU8a45, 2),
      ptr0 = _allocU8a46[0],
      len0 = _allocU8a46[1];

  wasm.ext_sr_from_seed(8, ptr0, len0);
  return resultU8a();
});
module.exports.sr25519Sign = withWasm(function (wasm, pubkey, secret, message) {
  var _allocU8a47 = allocU8a(pubkey),
      _allocU8a48 = _slicedToArray(_allocU8a47, 2),
      ptr0 = _allocU8a48[0],
      len0 = _allocU8a48[1];

  var _allocU8a49 = allocU8a(secret),
      _allocU8a50 = _slicedToArray(_allocU8a49, 2),
      ptr1 = _allocU8a50[0],
      len1 = _allocU8a50[1];

  var _allocU8a51 = allocU8a(message),
      _allocU8a52 = _slicedToArray(_allocU8a51, 2),
      ptr2 = _allocU8a52[0],
      len2 = _allocU8a52[1];

  wasm.ext_sr_sign(8, ptr0, len0, ptr1, len1, ptr2, len2);
  return resultU8a();
});
module.exports.sr25519Verify = withWasm(function (wasm, signature, message, pubkey) {
  var _allocU8a53 = allocU8a(signature),
      _allocU8a54 = _slicedToArray(_allocU8a53, 2),
      ptr0 = _allocU8a54[0],
      len0 = _allocU8a54[1];

  var _allocU8a55 = allocU8a(message),
      _allocU8a56 = _slicedToArray(_allocU8a55, 2),
      ptr1 = _allocU8a56[0],
      len1 = _allocU8a56[1];

  var _allocU8a57 = allocU8a(pubkey),
      _allocU8a58 = _slicedToArray(_allocU8a57, 2),
      ptr2 = _allocU8a58[0],
      len2 = _allocU8a58[1];

  var ret = wasm.ext_sr_verify(ptr0, len0, ptr1, len1, ptr2, len2);
  return ret !== 0;
});

module.exports.isReady = function () {
  return !!getWasm();
};

module.exports.waitReady = function () {
  return wasmPromise.then(function () {
    return !!getWasm();
  });
};